export default __webpack_public_path__ + "static/media/upload.aec41de7.gif";